import {Component} from "react";
import {Icon} from "office-ui-fabric-react";
import * as React from "react";
import { IRootState } from "../../../store";
import { connect } from "react-redux";

interface OnboardHelpBoxProps
{
    currentTimelineItemKey: string;
}

interface OnboardHelpBoxState
{

}

class OnboardHelpBox extends Component<OnboardHelpBoxProps,OnboardHelpBoxState>
{
    constructor(props: Readonly<OnboardHelpBoxProps>) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {

    }

    getVideoURL() {
        switch (this.props.currentTimelineItemKey) {
            case "mega-menu": {
                return "https://www.youtube.com/embed/xhLyQKNlwhI";
            }
            case "school-theme": {
                return "https://www.youtube.com/embed/yFw1nOQSsj4";
            }
            case "waiting": {
                return "https://www.youtube.com/embed/vnUqizTlsDs";
            }
        } 
        return "";
    }

    public render() {
        
        let videoURL: string = this.getVideoURL();
        
        const videoBox = (
            <div className="help-box-video">
                <iframe src={ videoURL } width="430" height="240" frameBorder="0" allow="autoplay;"></iframe>
            </div>
        );
        
        return (
            <div className={"flex-row flex--justify-content-center p-1rem"}>
                <div className="help-box-item help-box-item--row help-box-item--wide">

                    <div className={"flex-column flex-item--flex-1"}>
                        <div className="help-box-item__icon">
                            <Icon iconName="CloudUpload" className=""/>
                        </div>
                        <span className="help-box-item__title">School Onboarding</span>
                        <span className="help-box-item__description">
                                    <b>Let's Onboard Your School</b><br/><br/>
                                    You can access help at any time.
                                </span>
                    </div>

                    {videoURL ? videoBox : null}
                </div>
            </div>  
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { currentTimelineItemKey: string }): OnboardHelpBoxProps => {
        return {
            currentTimelineItemKey: ownProps.currentTimelineItemKey
        };
    }
)(OnboardHelpBox)